import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Select from "@material-ui/core/Select";
import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import PlaylistRule from "./PlaylistRule";

const useStyles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    width: "100%",
    boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.24)",
  },
  operatorDropdown: {
    marginRight: theme.spacing(6),
  },
  whiteButton: {
    marginRight: theme.spacing(1),
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
  },
});

class PlaylistRuleGroup extends React.Component {
  createNewChildGroup = () => {
    const { subConfig, onChangeSubConfig, orderPosition } = this.props;

    subConfig.push({ and: [] });

    onChangeSubConfig(subConfig, orderPosition);
  };

  onChildGroupChangeOperator = (newOperator, childOrderPosition) => {
    const { subConfig, onChangeSubConfig, orderPosition } = this.props;

    const childGroup = subConfig[childOrderPosition];
    const childGroupOldOuterOperator = childGroup.and ? "and" : "or";
    const childGroupOuterValue = childGroup[childGroupOldOuterOperator];

    subConfig[childOrderPosition] = {};
    subConfig[childOrderPosition][newOperator] = childGroupOuterValue;

    onChangeSubConfig(subConfig, orderPosition);
  };

  onChildGroupChangeSubConfig = (newSubConfig, childOrderPosition) => {
    const { subConfig, onChangeSubConfig, orderPosition } = this.props;

    const childGroup = subConfig[childOrderPosition];
    const childGroupOuterOperator = childGroup.and ? "and" : "or";

    subConfig[childOrderPosition][childGroupOuterOperator] = newSubConfig;

    onChangeSubConfig(subConfig, orderPosition);
  };

  onChildDelete = (childOrderPosition) => {
    const { subConfig, onChangeSubConfig, orderPosition } = this.props;

    subConfig.splice(childOrderPosition, 1);

    onChangeSubConfig(subConfig, orderPosition);
  };

  createNewChildRule = () => {
    const { subConfig, onChangeSubConfig, orderPosition } = this.props;

    subConfig.push({ field: "rating", operator: "geq", value: 5 });

    onChangeSubConfig(subConfig, orderPosition);
  };

  onChildRuleChange = (params, childOrderPosition) => {
    const { subConfig, onChangeSubConfig, orderPosition } = this.props;

    subConfig[childOrderPosition] = params;

    onChangeSubConfig(subConfig, orderPosition);
  };

  render() {
    const {
      classes,
      subConfig,
      isParentGroup,
      operator,
      onChangeOperator,
      onDelete,
      orderPosition,
    } = this.props;

    return (
      <Card className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <Select
              native
              value={operator}
              onChange={(e) => onChangeOperator(e.target.value, orderPosition)}
              className={classes.operatorDropdown}
            >
              <option value={"and"}>And</option>
              <option value={"or"}>Or</option>
            </Select>
            <Button
              variant="contained"
              size="small"
              className={classes.whiteButton}
              onClick={this.createNewChildGroup}
            >
              Add Group
            </Button>
            <Button
              variant="contained"
              size="small"
              className={classes.whiteButton}
              onClick={this.createNewChildRule}
            >
              Add Rule
            </Button>
            {isParentGroup ? (
              <div />
            ) : (
              <Button
                variant="contained"
                size="small"
                className={classes.deleteButton}
                onClick={() => onDelete(orderPosition)}
              >
                Delete Group
              </Button>
            )}
          </Grid>
          {subConfig.map((ruleOrGroup, i) => {
            const isGroup = ruleOrGroup.and || ruleOrGroup.or;
            if (!isGroup) {
              return (
                <PlaylistRule
                  key={i + ruleOrGroup.field + ruleOrGroup.value}
                  orderPosition={i}
                  field={ruleOrGroup.field}
                  operator={ruleOrGroup.operator}
                  value={ruleOrGroup.value}
                  onDelete={this.onChildDelete}
                  onChange={this.onChildRuleChange}
                />
              );
            }

            const outerOperator = ruleOrGroup.and ? "and" : "or";
            const outerValue = ruleOrGroup[outerOperator];

            const ChildRuleGroup = withStyles(useStyles)(PlaylistRuleGroup);

            return (
              <ChildRuleGroup
                key={i + outerOperator + JSON.stringify(outerValue)}
                orderPosition={i}
                operator={outerOperator}
                subConfig={outerValue}
                isParentGroup={false}
                onChangeOperator={this.onChildGroupChangeOperator}
                onChangeSubConfig={this.onChildGroupChangeSubConfig}
                onDelete={this.onChildDelete}
              />
            );
          })}
        </Grid>
      </Card>
    );
  }
}

export default withStyles(useStyles)(PlaylistRuleGroup);
